import { Pipe, PipeTransform } from '@angular/core';
import Utils from '../utils/utils';

@Pipe({ name: 'localDate' })
export class LocalDatePipe implements PipeTransform {

  transform(val: any): any {
    return Utils.localDate(val);
  }

}
